module.exports = __webpack_public_path__ + "static/media/Location_Book-Page37.55a9dceb.png";